import React from "react";
import {useTranslation} from "@Translation/hooks/useTranslation";

interface BusChangePopoverOverlayProps {
    stops: any[]
}

function BusChangePopoverOverlay({stops}: BusChangePopoverOverlayProps) {
    const style = {
        justifyContent: 'space-between',
    }

    const {
        station: stationLabel,
        arrival: arrivalLabel,
        departure: departureLabel,
        bus_change_message: busChangeMessage,
    } = useTranslation("sys")

    return (
        <>
            <p>{busChangeMessage}</p>
            <span className="gb--row" style={style}>
                <p className="gb--column">{stationLabel}</p>
                <p className="gb--column">{arrivalLabel}</p>
                <p className="gb--column">{departureLabel}</p>
            </span>
            {stops.map((stop) => (
                <span key={`${stop.n}--${stop.a}--${stop.d}`} className="gb--row" style={style}>
                    <p className="gb--column">{stop.n}</p>
                    <p className="gb--column">{stop.a}</p>
                    <p className="gb--column">{stop.d}</p>
                </span>
            ))}
        </>
    )
}

export default BusChangePopoverOverlay